'use strict';

exports.__esModule = true;
exports.TemplatesListView = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _View = require('../Template/View');

var _View2 = _interopRequireDefault(_View);

var _filters = require('@prisma-cms/filters');

var _filters2 = _interopRequireDefault(_filters);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {};
};

var TemplatesListView = exports.TemplatesListView = function (_PrismaCmsComponent) {
  _inherits(TemplatesListView, _PrismaCmsComponent);

  function TemplatesListView() {
    _classCallCheck(this, TemplatesListView);

    return _possibleConstructorReturn(this, _PrismaCmsComponent.apply(this, arguments));
  } // getColumns() {
  //   const {
  //     TemplateLink,
  //     UserLink,
  //     Grid,
  //   } = this.context;
  //   // return [];
  //   return [
  //     // {
  //     //   id: "id",
  //     // },
  //     // {
  //     //   id: "isPublic",
  //     //   label: "",
  //     //   renderer: (value, record) => {
  //     //     return <PublicIcon
  //     //       color={value === true ? "primary" : "disabled"}
  //     //     />;
  //     //   },
  //     // },
  //     {
  //       id: "name",
  //       label: "Название шаблона",
  //       renderer: (value, record) => {
  //         return record ? <TemplateLink
  //           object={record}
  //         /> : null;
  //       },
  //     },
  //     {
  //       id: "CreatedBy",
  //       label: "Владелец",
  //       renderer: (value) => {
  //         return value ? <UserLink
  //           user={value}
  //         /> : null;
  //       },
  //     },
  //     {
  //       id: "props",
  //       label: "Свойства",
  //       renderer: (value) => {
  //         return value ? <div
  //           style={{
  //             whiteSpace: "pre-wrap",
  //           }}
  //         >
  //           {JSON.stringify(value, true, 2)}
  //         </div> : null;
  //       },
  //     },
  //     {
  //       id: "components",
  //       label: "Компоненты",
  //       renderer: (value) => {
  //         return value ? <div
  //           style={{
  //             whiteSpace: "pre-wrap",
  //           }}
  //         >
  //           {JSON.stringify(value, true, 2)}
  //         </div> : null;
  //       },
  //     },
  //   ]
  // }


  TemplatesListView.prototype.render = function render() {
    var _context = this.context,
        Grid = _context.Grid,
        Pagination = _context.Pagination,
        uri = _context.uri;
    var _props = this.props,
        _props$data = _props.data,
        objectsConnection = _props$data.objectsConnection,
        first = _props$data.variables.first,
        classes = _props.classes,
        getFilters = _props.getFilters,
        setFilters = _props.setFilters;
    var templates = objectsConnection ? objectsConnection.edges.map(function (_ref) {
      var node = _ref.node;
      return node;
    }) : [];
    var total = objectsConnection ? objectsConnection.aggregate.count : 0;
    var pageVariable = "templates_page";
    var filters = getFilters();

    var _uri$query = uri.query(true),
        _uri$query$pageVariab = _uri$query[pageVariable],
        page = _uri$query$pageVariab === undefined ? 1 : _uri$query$pageVariab;

    return _PrismaCmsComponent.prototype.render.call(this, _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(Grid, {
      container: true,
      spacing: 16
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(_filters2.default, {
      queryName: "templates",
      filters: filters || {},
      setFilters: setFilters
    })), templates.map(function (n) {
      var id = n.id;
      return _react2.default.createElement(Grid, {
        key: id,
        item: true,
        xs: 12,
        xl: 6
      }, _react2.default.createElement(_View2.default, {
        data: {
          object: n
        },
        edit_button_styles: {
          position: "absolute"
        }
      }));
    })), _react2.default.createElement(Pagination, {
      pageVariable: pageVariable,
      limit: first,
      total: total,
      page: page || 1
    })));
  };

  return TemplatesListView;
}(_component2.default);

exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(TemplatesListView, props);
});